// test569
(569 && 0);
